import { SkuLocationImportResult, SkuLocationItem } from 'returnCenter-api';
import { skuLocationApi } from './api';

const skuLocation = {
    uploadSkuLocations: async (file: File, signal?: AbortSignal): Promise<SkuLocationImportResult> => {
        const options = signal ? { signal } : {};
        const response = await skuLocationApi.skuLocationUploadSkuLocationsPOST({ file }, options);
        return response.data;
    },
    getSkuLocations: async (): Promise<Array<SkuLocationItem>> => {
        const response = await skuLocationApi.skuLocationGetSkuLocations();
        return response.data;
    },
    getSkuLocationsBySkus: async (skus: string[], signal?: AbortSignal): Promise<{ [key: string]: string }> => {
        const options = signal ? { signal } : {};
        const response = await skuLocationApi.skuLocationGetSkuLocationsBySkusPOST({ requestBody: skus }, options);
        return response.data;
    },
    getTemplate: async (): Promise<Blob> => {
        const response = await skuLocationApi.skuLocationGetTemplate({ responseType: 'blob' });
        return response.data as unknown as Blob;
    },
};

export { skuLocation };
